<template>
  <el-card id="wallet">
    <template #header>
      <span>我的推广</span>
    </template>
    <el-row>
      <el-col :md="{span:22, offset: 1}" :xs="{span:24,offset:0}">
        <el-col class="walletGroup">
          <el-form ref="walletGroup" :model="walletGroup" label-width="80px">
            <el-row>
              <el-col :span="8">
                <el-form-item>
									<span slot="label">
										<span style="color:white">推广额:</span>
									</span>
                  <label>{{money.promoteMoney}}</label>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
									<span slot="label">
										<span style="color:white">提现额:</span>
									</span>
                  <label>{{money.withDrawlMoney}}</label>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
									<span slot="label">
										<span style="color:white">余额:</span>
									</span>
                  <label>{{money.leftMoney}}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button @click="withDrawlShow = true" size="small" style="width: 100%">提现</el-button>
            <div style="clear:both;"></div>
          </el-form>
        </el-col>
        <div style="clear:both;"></div>
        <el-row>
          <el-col>
            <el-tabs v-model="active_tab">
              <el-tab-pane label="推广列表" name="promoteRecord">
                <h3 style="margin: 10px">推广列表</h3>
                <PersonCenterTable :table="promoteRecordTable" @get-data="getData('promote')">
                  <template #tableColumn>
                    <el-table-column prop="companyName" label="推广公司"></el-table-column>
                    <el-table-column prop="createTime" label="推广时间"></el-table-column>
                    <el-table-column prop="effectStatus" label="是否生效">
                      <template slot-scope="scope">
                        <span v-if="scope.row.effectStatus == 0">否</span>
                        <span v-if="scope.row.effectStatus == 1">是</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="promoteMoney" label="金额">
                      <template slot-scope="scope">
                        <span style="color:#0155f5">{{ scope.row.promoteMoney }}元</span>
                      </template>
                    </el-table-column>
                  </template>
                </PersonCenterTable>
              </el-tab-pane>
              <el-tab-pane label="提现列表" name="withDrawlRecord">
                <h3 style="margin: 10px">提现列表</h3>
                <person-center-table :table="withDrawlRecordTable" @get-data="getData('withDrawl')">
                  <template #tableColumn>
                    <el-table-column prop="createTime" label="提现时间"></el-table-column>
                    <el-table-column prop="state" label="是否支付">
                      <template slot-scope="scope">
                        <span v-if="scope.row.state == 0">否</span>
                        <span v-if="scope.row.state == 1">是</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="withdrawlMoney" label="金额">
                      <template slot-scope="scope">
                        <span style="color:#0155f5">{{ scope.row.withdrawlMoney }}元</span>
                      </template>
                    </el-table-column>
                  </template>
                </person-center-table>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>


      </el-col>
    </el-row>

    <el-dialog title="提现金额" :visible.sync="withDrawlShow">
      <el-form >
        <el-form-item label="请输入提现金额" style="margin-left: 10px;margin-right: 10px;" label-width="200">
          <el-input v-model="withDrawlMoneyNow" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="withDrawlShow = false;withDrawlMoneyNow = 0">取 消</el-button>
        <el-button type="primary" @click="userWithdrawlApply">确 定</el-button>
      </div>
    </el-dialog>

  </el-card>
</template>

<script>
import MyWalletMixin from "@/pages/userCenter/Mixins/MyWalletMixin";
import PersonCenterTable from "@/pages/userCenter/ChildComps/PersonCenterTable";
export default {
  components: {
    PersonCenterTable,
  },
  mixins: [MyWalletMixin]
}
</script>

<style lang="less">
/*钱包表单*/
#wallet {
  background-color: #ffffff;

  .charge_record .el-table td,
  .el-table th {
    padding: 4px 0px !important;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .charge_record .el-table td div,
  #wallet .charge_record .el-table td span {
    font-size: 15px !important;
  }

  .walletGroup .el-form {
    margin: 0px;
    padding: 15px;
    background-color: #3e70c7;
    border-radius: 10px;
  }

  .walletGroup .el-form-item {
    margin-bottom: 0px !important;
  }

  .walletGroup .el-form-item label {
    padding: 0 0 0 20px;
    color: #ffffff;
    text-align: left;
  }

  .toolTip>div {
    text-align: center;
  }

  .el-divider--horizontal {
    margin: 5px 0px;
  }

  .cardService button {
    display: block;
    margin: 5px 0px !important;
    width: 100%;
    text-align: left;
  }

  .cardService .el-button [class*=el-icon-]+span {
    margin-left: 25px;
  }
}
</style>
